// Vuetify Documentation https://vuetifyjs.com

import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import {
  VCol,
  VRow,
} from 'vuetify/lib'

Vue.use(Vuetify, {
  components: {
    VCol,
    VRow,
  },
})

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#001F48',
        secondary: '#008493',
        accent: '#3EC2D1',
        fourth: '#FF6600',
        tertiary: '#3EC2D1',
        readonly: '#ECEFF1',
        write: '#eceff159',
        date: '#99ffad',
        time: '#FF9800',
        numeric: '#c7edf1',
        combo: '#fff596',
        more: '#00ff00',

      },
      dark: {},
    },
  },
})
